import React, {useEffect} from 'react';
import {Spinner} from '@chakra-ui/react';
import FileSaver from 'file-saver';
import {createApiQuery} from '../../hooks/api/api';
import {ObjectId} from 'bson';
import {GetSalesforceErrors} from '../../shared/api/definitions/integration';

const useSalesforceErrors = createApiQuery(
  GetSalesforceErrors,
  (params) => ['salesforceErrors', params],
  {
    staleTime: Infinity,
  }
);

const downloadErrors = async (data: string) => {
  try {
    const blob = new Blob([data], {type: 'text/csv'});
    FileSaver.saveAs(blob, `sf-errors-${new Date().toISOString()}.csv`);
  } catch (err) {
    console.error('Error downloading Salesforce errors:', err);
  }
};

/**
 * Component that downloads Salesforce errors as a CSV file
 * It requires customerId and jobId as props
 */
export const SalesforceErrorsDownloader = ({
  rawCustomerId,
  jobIds,
}: {
  rawCustomerId: string | null;
  jobIds: string[];
}) => {
  const customerId = React.useMemo(
    () => (rawCustomerId ? new ObjectId(rawCustomerId) : undefined),
    [rawCustomerId]
  );
  const {isPending, isError, data} = useSalesforceErrors({
    customerId,
    jobIds,
  });

  useEffect(() => {
    if (data) {
      downloadErrors(data);
    }
  }, [data]);

  if (isPending) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error downloading Salesforce errors.</div>;
  }

  return <></>;
};
